import { Route, Routes } from 'react-router'
import { ChooseNumber } from 'pages/settings/pages/compliance/pages/tollFree/pages/AddTollFreeNumber/ui/ChooseNumber/ChooseNumber'
import { AssignNumber } from 'pages/settings/pages/compliance/pages/tollFree/pages/AddTollFreeNumber/ui/AssignNumber/AssignNumber'
import { TollFreeAddNumberStepsLayout } from 'pages/settings/pages/compliance/pages/tollFree/layout/TollFreeAddNumberStepsLayout'
import { Payment } from 'pages/settings/pages/compliance/pages/tollFree/pages/AddTollFreeNumber/ui/Payment/Payment'
import { TollFreeAddNumberAccessLayout } from 'pages/settings/pages/compliance/pages/tollFree/layout/TollFreeAddNumberAccessLayout'
import { Numbers } from 'pages/settings/pages/compliance/pages/tollFree/pages/AddTollFreeNumber/ui/Numbers/Numbers'

import { TollFreeAddNumberLayout } from 'pages/settings/pages/compliance/pages/tollFree/layout/TollFreeAddNumberLayout'
import { TollFreeAddNumberRoutesSteps } from './type'

export const AddNumberRouter = () => {
  return (
    <Routes>
      <Route element={<TollFreeAddNumberAccessLayout />}>
        <Route element={<TollFreeAddNumberLayout />}>
          <Route path={TollFreeAddNumberRoutesSteps.Numbers} element={<Numbers />} />
        </Route>

        <Route element={<TollFreeAddNumberStepsLayout />}>
          <Route path={TollFreeAddNumberRoutesSteps.ChooseNumber} element={<ChooseNumber />} />
          <Route path={TollFreeAddNumberRoutesSteps.AssignNumber} element={<AssignNumber />} />
          <Route path={TollFreeAddNumberRoutesSteps.Payment} element={<Payment />} />

          <Route path='*' element={<div>Page Not Found</div>} />
        </Route>
      </Route>
    </Routes>
  )
}
